/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateSecurityDomainDto } from '../models/CreateSecurityDomainDto';
import type { DeletedResponse } from '../models/DeletedResponse';
import type { SecurityDomainResponse } from '../models/SecurityDomainResponse';
import type { UpdateSecurityDomainDto } from '../models/UpdateSecurityDomainDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SecurityDomainsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List all security domains
     * Returns a paginated list of security domains with optional filters for enabled status and search.
     * @returns any Security domains returned successfully.
     * @throws ApiError
     */
    public securityDomainsControllerFindAll({
        page = 1,
        limit = 50,
        enabled,
        search,
        sortBy = 'frenchLabel',
        sortOrder = 'asc',
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page
         */
        limit?: number,
        /**
         * Filter by enabled status
         */
        enabled?: boolean,
        /**
         * Search by French or English label
         */
        search?: string,
        /**
         * Sort field
         */
        sortBy?: 'frenchLabel' | 'englishLabel' | 'createdAt',
        /**
         * Sort order
         */
        sortOrder?: 'asc' | 'desc',
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/security-domains',
            query: {
                'page': page,
                'limit': limit,
                'enabled': enabled,
                'search': search,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
            },
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Create a security domain (admin)
     * Creates a new security domain. Admin only.
     * @returns SecurityDomainResponse Security domain created successfully.
     * @throws ApiError
     */
    public securityDomainsControllerCreate({
        requestBody,
    }: {
        requestBody: CreateSecurityDomainDto,
    }): CancelablePromise<SecurityDomainResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/security-domains',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
                409: `Security domain with this French label already exists.`,
            },
        });
    }
    /**
     * Get security domain by ID
     * Returns a single security domain by its unique identifier.
     * @returns SecurityDomainResponse Security domain found.
     * @throws ApiError
     */
    public securityDomainsControllerFindOne({
        id,
    }: {
        /**
         * Security domain unique identifier
         */
        id: string,
    }): CancelablePromise<SecurityDomainResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/security-domains/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                404: `Security domain not found.`,
            },
        });
    }
    /**
     * Update a security domain (admin)
     * Updates an existing security domain. Admin only.
     * @returns SecurityDomainResponse Security domain updated successfully.
     * @throws ApiError
     */
    public securityDomainsControllerUpdate({
        id,
        requestBody,
    }: {
        /**
         * Security domain unique identifier
         */
        id: string,
        requestBody: UpdateSecurityDomainDto,
    }): CancelablePromise<SecurityDomainResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/security-domains/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
                404: `Security domain not found.`,
                409: `Security domain with this French label already exists.`,
            },
        });
    }
    /**
     * Delete a security domain (admin)
     * Deletes a security domain. Admin only.
     * @returns DeletedResponse Security domain deleted successfully.
     * @throws ApiError
     */
    public securityDomainsControllerRemove({
        id,
    }: {
        /**
         * Security domain unique identifier
         */
        id: string,
    }): CancelablePromise<DeletedResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/security-domains/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
                404: `Security domain not found.`,
            },
        });
    }
}
